import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';
import avo from 'analytics/avo';

import useSuspenseQuery from 'commons/useSuspenseQuery';
import { getRudderStackAnonymousId } from 'commons/localStorage';
import { GET_RECOMMENDED_PRODUCTS } from 'mocks/queries';
import ProductCardCarousel from './index';

const RecommendedForYouCarousel = ({ currentPDPProduct }) => {
  const { loading, data } = useSuspenseQuery(GET_RECOMMENDED_PRODUCTS, {
    variables: { tuID: getRudderStackAnonymousId(), limit: 10 },
    fetchPolicy: 'network-only',
    ssr: false,
  });

  if (
    !loading &&
    data?.getRecommendedProducts &&
    data.getRecommendedProducts.length > 0
  ) {
    const removedSkuWithZero =
      data.getRecommendedProducts.filter(rp => rp.sku !== '0') || [];

    const apiData =
      removedSkuWithZero?.length && currentPDPProduct
        ? removedSkuWithZero?.filter(
            apiD => apiD.sku !== currentPDPProduct.toString()
          )
        : removedSkuWithZero;

    const products = orderBy(apiData, ['score'], 'desc').map(
      product => product.sku
    );

    return (
      <ProductCardCarousel
        analyticsComponentName={avo.Component.PRODUCT_RECOMMENDATION_CAROUSEL}
        ids={products.map(pId => parseInt(pId, 10))}
        idType="id"
        title="You might also like"
      />
    );
  }
  return null;
};

RecommendedForYouCarousel.propTypes = {
  currentPDPProduct: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default RecommendedForYouCarousel;
